import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { IntersectionObserverModule } from 'src/core-lib/intersection-observer/intersection-observer.module';
import { PipeModule } from 'src/core-lib/pipes/pipe.module';
import { InfiniteScrollComponent } from './infinite-scroll/infinite-scroll.component';
import { LoadMoreComponent } from './load-more/load-more.component';
import { PaginationPageComponent } from './pagination-page/pagination-page.component';
import { PaginationDirective } from './pagination.directive';
import { PaginationComponent } from './pagination/pagination.component';



@NgModule({
    declarations: [
        PaginationComponent,
        LoadMoreComponent,
        InfiniteScrollComponent,
        PaginationDirective,
        PaginationPageComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        PipeModule,
        IntersectionObserverModule,
    ],
    exports: [
        PaginationComponent,
        LoadMoreComponent,
        InfiniteScrollComponent,
        PaginationDirective,
        PaginationPageComponent
    ]
})
export class PaginationModule {}
